<ng-container rtBlock="sc-terms-page">
    <sc-page-header>
        <h1 slot="title" i18n="@@breadcrumbTerms">Пользовательское соглашение</h1>
    </sc-page-header>

    <section rtElem="banner">
        <div rtElem="banner-cell">
            <div rtElem="banner-num">01</div>
            <div>
                <h2 rtElem="banner-h4" i18n="@@termsBanner1Title">Бесплатно</h2>
                <p rtElem="banner-p" i18n="@@termsBanner1Text">Сервис предоставляется на безвозмездной основе без регистрации.</p>
            </div>
        </div>
        <div rtElem="banner-cell">
            <div rtElem="banner-num">02</div>
            <div>
                <h2 rtElem="banner-h4" i18n="@@termsBanner2Title">AS-IS</h2>
                <p rtElem="banner-p" i18n="@@termsBanner2Text">Расчёт — ориентировочный. Окончательная геометрия — за инженером.</p>
            </div>
        </div>
        <div rtElem="banner-cell">
            <div rtElem="banner-num">03</div>
            <div>
                <h2 rtElem="banner-h4" i18n="@@termsBanner3Title">Без гарантий</h2>
                <p rtElem="banner-p" i18n="@@termsBanner3Text">Оператор не несёт ответственности за реализацию лестницы по расчёту.</p>
            </div>
        </div>
    </section>

    <div rtElem="body">
        <aside rtElem="toc" aria-label="Table of contents" i18n-aria-label="@@termsTocLabel">
            <h2 rtElem="toc-title" i18n="@@termsTocHead">Содержание</h2>
            <ol rtElem="toc-list">
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s1"
                        i18n="@@termsToc1"
                        [rtMod]="{ active: activeSectionId() === 's1' }"
                        (click)="onTocClick($event, 's1')">
                        Термины
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s2"
                        i18n="@@termsToc2"
                        [rtMod]="{ active: activeSectionId() === 's2' }"
                        (click)="onTocClick($event, 's2')">
                        Предмет
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s3"
                        i18n="@@termsToc3"
                        [rtMod]="{ active: activeSectionId() === 's3' }"
                        (click)="onTocClick($event, 's3')">
                        Порядок использования
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s4"
                        i18n="@@termsToc4"
                        [rtMod]="{ active: activeSectionId() === 's4' }"
                        (click)="onTocClick($event, 's4')">
                        Ответственность
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s5"
                        i18n="@@termsToc5"
                        [rtMod]="{ active: activeSectionId() === 's5' }"
                        (click)="onTocClick($event, 's5')">
                        Интеллектуальная собственность
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s6"
                        i18n="@@termsToc6"
                        [rtMod]="{ active: activeSectionId() === 's6' }"
                        (click)="onTocClick($event, 's6')">
                        Разрешение споров
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s7"
                        i18n="@@termsToc7"
                        [rtMod]="{ active: activeSectionId() === 's7' }"
                        (click)="onTocClick($event, 's7')">
                        Заключительные положения
                    </a>
                </li>
            </ol>
        </aside>

        <main rtElem="main">
            <section rtElem="section" id="s1">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">01 /</span>
                    <span i18n="@@termsS1Title">Термины</span>
                </h2>
                <p rtElem="section-p">
                    <b i18n="@@termsS1TermService">Сервис</b>
                    <span i18n="@@termsS1DefService">
                        — онлайн-конструктор GoldenCalc, доступный на goldencalc.ru, goldencalc.by и goldencalc.com.
                    </span>
                    <br />
                    <b i18n="@@termsS1TermOperator">Оператор</b>
                    <span i18n="@@termsS1DefOperator">— физическое или юридическое лицо, разместившее Сервис.</span>
                    <br />
                    <b i18n="@@termsS1TermUser">Пользователь</b>
                    <span i18n="@@termsS1DefUser">— любое лицо, использующее Сервис в любой форме.</span>
                    <br />
                    <b i18n="@@termsS1TermCalc">Расчёт</b>
                    <span i18n="@@termsS1DefCalc">
                        — ориентировочный результат геометрии и материалов, полученный Пользователем. Смета и цена предоставляются по
                        запросу.
                    </span>
                </p>
            </section>

            <section rtElem="section" id="s2">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">02 /</span>
                    <span i18n="@@termsS2Title">Предмет соглашения</span>
                </h2>
                <p rtElem="section-p" i18n="@@termsS2Body">
                    Оператор безвозмездно предоставляет Пользователю неисключительное право использования Сервиса для расчёта деревянных
                    лестниц. Все функции Сервиса доступны без регистрации и без ограничений по количеству расчётов.
                </p>
            </section>

            <section rtElem="section" id="s3">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">03 /</span>
                    <span i18n="@@termsS3Title">Порядок использования</span>
                </h2>
                <p rtElem="section-p" i18n="@@termsS3Body">
                    Пользователь вправе использовать результаты Расчёта в личных, профессиональных и коммерческих целях. Пользователь не
                    вправе использовать автоматизированные средства для нагрузочного тестирования Сервиса или для реверс-инжиниринга логики
                    расчёта.
                </p>
            </section>

            <section rtElem="section" id="s4">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">04 /</span>
                    <span i18n="@@termsS4Title">Ответственность сторон</span>
                </h2>
                <div rtElem="callout" [rtMod]="{ err: true }">
                    <div rtElem="callout-tag" i18n="@@termsCalloutTag">Важно</div>
                    <span i18n="@@termsCalloutBody">
                        Сервис предоставляется «КАК ЕСТЬ». Оператор не несёт ответственности за качество изготовления и безопасность
                        лестниц, произведённых по Расчёту. Окончательная проверка геометрии и соответствия строительным нормам — обязанность
                        Пользователя или нанятого им инженера.
                    </span>
                </div>
                <p rtElem="section-p" i18n="@@termsS4Body">
                    Оператор не гарантирует, что Сервис будет работать без перебоев или без ошибок, и не принимает на себя обязательств по
                    своевременному устранению дефектов.
                </p>
            </section>

            <section rtElem="section" id="s5">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">05 /</span>
                    <span i18n="@@termsS5Title">Интеллектуальная собственность</span>
                </h2>
                <p rtElem="section-p" i18n="@@termsS5Body">
                    Исходный код Сервиса, дизайн интерфейса и алгоритмы расчёта принадлежат Оператору. Результаты Расчёта (конфигурации,
                    экспорты JSON и PNG) принадлежат Пользователю и могут использоваться им без ограничений.
                </p>
            </section>

            <section rtElem="section" id="s6">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">06 /</span>
                    <span i18n="@@termsS6Title">Разрешение споров</span>
                </h2>
                <p rtElem="section-p" i18n="@@termsS6Body">
                    Споры, возникающие в связи с использованием Сервиса, разрешаются путём переговоров. При недостижении соглашения — в
                    судебном порядке по месту нахождения Оператора в соответствии с применимым правом.
                </p>
            </section>

            <section rtElem="section" id="s7">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">07 /</span>
                    <span i18n="@@termsS7Title">Заключительные положения</span>
                </h2>
                <p rtElem="section-p" i18n="@@termsS7Body">
                    Соглашение вступает в силу с момента начала использования Сервиса. Оператор вправе изменять условия Соглашения в
                    одностороннем порядке. Продолжение использования Сервиса после публикации изменений означает согласие с новой редакцией.
                </p>
            </section>
        </main>
    </div>
</ng-container>
